import React from "react";

function BSCHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Empowering Projects on Binance Smart Chain (BSC)
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Xeer Technology offers tailored development solutions on
                    Binance Smart Chain, helping you launch high-performance
                    DApps and DeFi platforms with fast transactions and minimal
                    fees.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BSCHero;
